export const convertStripeToFirstPayCardBrand = (brand) => {
    switch (brand) {
        case 'visa':
            return 'VISA';
        case 'mastercard':
            return 'MASTER';
        case 'amex':
            return 'AMEX';
        case 'diners':
            return 'DINERS';
        case 'discover':
            return 'DISCOVER';
        case 'jcb':
            return 'JCB';
        case 'unionpay':
            return 'UNIONPAY';
        case 'unknown':
            return 'UNIONPAY';
    }
};
